export enum TimeoutEnum {
  VeryShort = 300,
  Short = 700,
  MediumShort = 1500,
  Medium = 3000,
  MediumLong = 5000,
  Long = 7000,
  VeryLong = 10000,
}
